import type { FaireProductEntity } from "../../entity_types/product";

export const p_5v2jah6dtc: FaireProductEntity = {
  token: "p_5v2jah6dtc",
  type: "product",
  name: "Trendy Floral Design Blazer Jacket For Women",
  brandToken: "b_999ccmmbkw",
  brandName: "Halcyon Outfitters®",
  imageUrl:
    "https://cdn.faire.com/fastly/9bcaf0cd1d7c5b4910afc1c8c6935daa382039be3164e0518d09bd1dc73c2889.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ac7828d406e5447e043c71bd90109c72c8df83702e522b1b0547fafd3c98875f.jpeg",
    "https://cdn.faire.com/fastly/5d3de47ee18f2386b80b572f161ddc2cb7179a6e1e43f1495d29c62c7bb6762e.jpeg",
    "https://cdn.faire.com/fastly/5ac8abc5790a084098fe8fc8a2698a85b57e6521c47a4af1ded66ead82d60780.jpeg",
    "https://cdn.faire.com/fastly/a2d0a043540b7dc464ec937eeec3949133bd594843d25463e2f76c822dcc80d4.jpeg",
    "https://cdn.faire.com/fastly/a4e3b540f6c0cfb10f210d50155d0cce0aed030dc775cc50e6c2d1433eccd9b9.jpeg",
    "https://cdn.faire.com/fastly/3f9f642fbada013f11391864497983ccc85debe7593e8261207a09edb76a9324.jpeg",
  ],
  priceDollars: 33.26,
  description:
    "This stylish blazer jacket features a trendy floral design and is made from high-quality polyester fabric. With a medium thickness, it's suitable for all-season wear. The jacket has a regular fit, classic long sleeves, and a versatile open front design with a tie closure. Available in a variety of colors including white, yellow, apricot, and printed white. This is an essential piece for commuting and daily wear.\nFeatures: \n * Material: Polyester \n * Fit: Regular (consider sizing up for a looser fit) \n * Length: Regular length (approximately 50 cm) \n * Sleeve Length: Long sleeves \n * Care: Easy-care, wrinkle-resistant fabric \n * Style: Elegant and professional \n * Available Sizes: S, M, L, XL, 2XL, 3XL \nThis blazer jacket combines elegance and comfort, making it a perfect choice for various occasions, whether you're heading to the office or going out with friends.\n",
  tags: [],
  msrpDollars: 66.51,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:38.107Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
